import {
  FormControl,
  FormHelperText,
  FormLabel,
  MenuItem,
  TextField,
} from '@mui/material'
import Box from '@mui/material/Box'
import React from 'react'
import { string } from 'yup'
import { useTranslation } from 'react-i18next'

import { getYears } from 'lib/DateHelper'
import { setAnswer } from 'redux/slices/SignupFormAnswers'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { getErrorHelperText } from 'lib/participantProfile/Helper'

export const validateYearQuestion = async (
  answer: { value: string },
  question: QuestionsItems,
): Promise<string[]> => {
  let schema = string().nullable()
  if (question.required) {
    schema = schema.required()
  }
  try {
    await schema.validate(answer?.value)
    return []
  } catch (err: any) {
    return err.errors
  }
}

const YearQuestion = ({
  question,
  id,
  readOnlyMode,
  required,
}: YearQuestionProps) => {
  const { t } = useTranslation()
  const { answers, errors } = useAppSelector((state) => state.signupAnswers)

  const error = errors[id] || []
  const year = new Date(answers[id]?.value).getFullYear() || ''

  const dispatch = useAppDispatch()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const answer = event.target.value

    dispatch(
      setAnswer({
        questionId: id,
        answer: { value: answer ? `01/01/${answer}` : '' },
      }),
    )
  }

  return (
    <Box id={id}>
      <FormControl error={error.length > 0} fullWidth required={required}>
        <FormLabel> {question} </FormLabel>
        <TextField
          select
          value={year}
          error={error.length > 0}
          onChange={handleChange}
          variant="standard"
          data-testid="year-question"
          InputProps={{
            readOnly: readOnlyMode,
          }}
        >
          {!required && (
            <MenuItem key="year_question_none_value" value="">
              {t(`filters.status.none`)}
            </MenuItem>
          )}
          {getYears().map((year, index) => (
            <MenuItem key={index} value={year.toString()}>
              {year}
            </MenuItem>
          ))}
        </TextField>
        <FormHelperText sx={{ ml: 0 }}>
          {getErrorHelperText(error, question)}
        </FormHelperText>
      </FormControl>
    </Box>
  )
}

export default YearQuestion
